/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Ground_FloorInputs */

const cs_enum_ground_floor = /** @type {(inputs: Enum_Ground_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přízemní`)
};

const en_enum_ground_floor = /** @type {(inputs: Enum_Ground_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ground floor`)
};

/**
* | output |
* | --- |
* | "Ground floor" |
*
* @param {Enum_Ground_FloorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_ground_floor = /** @type {((inputs?: Enum_Ground_FloorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Ground_FloorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_ground_floor(inputs)
	return cs_enum_ground_floor(inputs)
});